import { Card, CardContent, Typography } from '@mui/material';
import React from 'react';

export const EmptyStateContent: React.FC<{
  title: string;
  message: string;
  icon: React.ReactNode;
  button?: React.ReactNode;
  showBorder?: boolean;
}> = ({ title, message, icon, button, showBorder = true }) => {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(showBorder
          ? {}
          : {
              boxShadow: 'none',
              border: 'none',
              backgroundColor: 'transparent',
            }),
      }}
    >
      <CardContent sx={{ textAlign: 'center', maxWidth: 400, margin: '0 auto' }}>
        {React.cloneElement(icon as React.ReactElement, {
          sx: { fontSize: 50, color: 'text.secondary', mb: 2 },
        })}
        <Typography variant="h6" color="text.secondary" textAlign="center">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mt: 1, mb: 2 }}>
          {message}
        </Typography>
        {button}
      </CardContent>
    </Card>
  );
};
